<template>
    <div class="ds-card-selectable-item">
        <DsCard
            autoFocus
            v-bind="$attrs"
            clickable
            :disabled
            :error
            :selected
            variant="interactive"
        >
            <div
                class="flex h-full gap-4"
                :class="{
                    'flex-row-reverse': formControlPosition === 'right',
                    'items-center': alignContent === 'center',
                    'items-start': alignContent === 'start',
                }"
            >
                <div class="form-control-wrapper translate-y-0.5">
                    <slot name="formControl" />
                </div>
                <div class="flex-1">
                    <slot>
                        <span
                            v-if="label"
                            class="text-content-md text-content-primary"
                        >
                            {{ label }}
                        </span>
                    </slot>
                </div>
            </div>
        </DsCard>
        <p
            v-if="helperText"
            class="mt-1 text-content-md text-content-secondary"
        >
            {{ helperText }}
        </p>
    </div>
</template>

<script setup lang="ts">
import DsCard from '@/components/design-system/DsCard.vue';

export interface CardSelectableItemProps {
    label?: string;
    helperText?: string;
    alignContent?: 'center' | 'start';
    formControlPosition?: 'left' | 'right';
    selected?: boolean;
    error?: string | boolean;
    autoFocus?: boolean;
    disabled?: boolean;
}

withDefaults(defineProps<CardSelectableItemProps>(), {
    alignContent: 'center',
    formControlPosition: 'left',
    selected: false,
    error: false,
    autoFocus: false,
    disabled: false,
});

defineEmits<{
    toggle: [];
}>();

defineSlots<{
    default: () => void;
    formControl: () => void;
}>();
</script>

<style scoped lang="scss">
.ds-card-selectable-item {
    @apply select-none;

    .form-control-wrapper {
        @apply flex-shrink-0;
    }
}
</style>
